
/**
 * @typedef ApiOptions
 * @prop {string} apiUrl
 * @prop {Function} fetch
 */

export class ApiError extends Error {
  /** @type {Record<string, any>?} */
  data = null

  /**
   * @param {string} message
   * @param {Record<string, any>=} data
   */
  constructor(message, data) {
    super(message)
    if (data != null) {
      this.data = data
    }
  }

  toJSON() {
    return {
      message: this.message,
      ...(this.data != null ? { data: this.data } : {}),
    }
  }
}
